// var expressAccountList = []
// var orderList = [];
// var userInfo = {};
// var workOrderList = [];
// var jwtToken = '';
var expressAccountList = JSON.parse(localStorage.getItem('expressAccountList'));
var orderList = JSON.parse(localStorage.getItem('orderList'));
var userInfo = JSON.parse(localStorage.getItem('userInfo'));
var workOrderList = JSON.parse(localStorage.getItem('workOrderList'));
var jwtToken = localStorage.getItem('jwtToken');
var requestUrl = 'https://open.jfcorp.cn/express';
// var requestUrl = 'http://8.134.179.130:6/express';
// var requestUrl = "http://127.0.0.1:6/express";
var uploadUrl = requestUrl+ '/uploadFile';
var expressLogoUrl = 'https://open.jfcorp.cn/expressLogo/';

export default {
  expressAccountList,
  orderList,
  userInfo,
  workOrderList,
  requestUrl,
  uploadUrl,
  expressLogoUrl,
  jwtToken
};